"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@seedlang/utils");
var _mobx = require("mobx");
var _serializr = require("serializr");
var _level = _interopRequireDefault(require("./level"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _sentence_simple = _interopRequireDefault(require("./sentence_simple"));
var _translation_basic = _interopRequireDefault(require("./translation_basic"));
var _translation_source_basic = _interopRequireDefault(require("./translation_source_basic"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Meaning = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source_basic["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_sentence_simple["default"]))), _dec7 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function Meaning() {
    var _this;
    _classCallCheck(this, Meaning);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Meaning, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "highlightedExampleSentence", _descriptor2, _this);
    _initializerDefineProperty(_this, "highlightedExampleTranslation", _descriptor3, _this);
    _initializerDefineProperty(_this, "synonymMatches", _descriptor4, _this);
    _initializerDefineProperty(_this, "position", _descriptor5, _this);
    _initializerDefineProperty(_this, "score", _descriptor6, _this);
    _initializerDefineProperty(_this, "register", _descriptor7, _this);
    _initializerDefineProperty(_this, "isPreview", _descriptor8, _this);
    _initializerDefineProperty(_this, "hasSynonyms", _descriptor9, _this);
    _initializerDefineProperty(_this, "level", _descriptor0, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor1, _this);
    _initializerDefineProperty(_this, "sentences", _descriptor10, _this);
    _initializerDefineProperty(_this, "synonyms", _descriptor11, _this);
    _this.translationSourcesForUser = function (user) {
      if (!(0, _utils.isPresent)(_this.translationSources)) return [];
      var userLangId = (user === null || user === void 0 ? void 0 : user.languageId) || 'EN';
      var prefersBritishEnglish = userLangId === 'EN2' || userLangId === 'EN' && (user === null || user === void 0 ? void 0 : user.useBritishEnglish);
      var preferredLangId = prefersBritishEnglish ? 'EN2' : userLangId;
      var byScore = function byScore(sourceA, sourceB) {
        return (sourceB.aggregateScore || 0) - (sourceA.aggregateScore || 0);
      };
      var sourcesByLanguage = {};
      _this.translationSources.forEach(function (translationSource) {
        if (!(translationSource !== null && translationSource !== void 0 && translationSource.source) || !(translationSource.accepted || !translationSource.userId)) {
          return;
        }
        var languageId = translationSource.source.languageId;
        if (!sourcesByLanguage[languageId]) {
          sourcesByLanguage[languageId] = [];
        }
        sourcesByLanguage[languageId].push(translationSource);
      });
      Object.values(sourcesByLanguage).forEach(function (sources) {
        sources.sort(byScore);
      });
      var sourcesForLanguage = function sourcesForLanguage(languageId) {
        return sourcesByLanguage[languageId] || [];
      };
      var englishLanguageIds = prefersBritishEnglish ? ['EN2', 'EN'] : ['EN', 'EN2'];
      var englishSources = englishLanguageIds.reduce(function (accumulator, languageId) {
        return accumulator.concat(sourcesForLanguage(languageId));
      }, []);
      if (userLangId.startsWith('EN')) {
        var preferredSources = sourcesForLanguage(preferredLangId);
        if ((0, _utils.isPresent)(preferredSources)) {
          return preferredSources;
        }
        var fallbackLanguageId = preferredLangId === 'EN2' ? 'EN' : 'EN2';
        return sourcesForLanguage(fallbackLanguageId);
      }
      var nativeSources = Object.keys(sourcesByLanguage).reduce(function (accumulator, languageId) {
        if (!languageId.startsWith('EN') && languageId === userLangId) {
          return accumulator.concat(sourcesForLanguage(languageId));
        }
        return accumulator;
      }, []).sort(byScore);
      if (user !== null && user !== void 0 && user.onlyShowNativeLanguage) {
        if ((0, _utils.isPresent)(nativeSources)) {
          return nativeSources;
        }
        return englishSources;
      }
      if ((user === null || user === void 0 ? void 0 : user.showNativeLanguageFirst) !== false) {
        return nativeSources.concat(englishSources);
      }
      return englishSources.concat(nativeSources);
    };
    _this.sourceTextListForUser = function (user) {
      var word = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return _this.translationSourcesForUser(user).map(function (ts) {
        var _ts$source, _ts$source2, _ts$source3;
        var sourceText = user && (_ts$source = ts.source) !== null && _ts$source !== void 0 && _ts$source.textForUser ? ts.source.textForUser(user) : (_ts$source2 = ts.source) === null || _ts$source2 === void 0 ? void 0 : _ts$source2.text;
        if (!sourceText) return null;
        if ((_ts$source3 = ts.source) !== null && _ts$source3 !== void 0 && _ts$source3.displayGender && word !== null && word !== void 0 && word.genderAbbreviation) {
          return "".concat(sourceText).concat(word.genderAbbreviation);
        }
        return sourceText;
      }).filter(function (text) {
        return text;
      }).join(', ');
    };
    return _this;
  }
  _inherits(Meaning, _RootModel);
  return _createClass(Meaning, [{
    key: "enSources",
    get: function get() {
      return this.translationSources.filter(function (ts) {
        var _ts$source4;
        return ((_ts$source4 = ts.source) === null || _ts$source4 === void 0 ? void 0 : _ts$source4.languageId) === 'EN';
      });
    }
  }, {
    key: "enSourcesString",
    get: function get() {
      return this.enSources.map(function (ts) {
        var _ts$source5;
        return (_ts$source5 = ts.source) === null || _ts$source5 === void 0 ? void 0 : _ts$source5.text;
      }).join(', ');
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "highlightedExampleSentence", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "highlightedExampleTranslation", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "synonymMatches", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "score", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "register", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isPreview", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasSynonyms", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "level", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "sentences", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "synonyms", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "enSources", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enSourcesString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enSourcesString"), _class.prototype), _class);
var _default = exports["default"] = Meaning;